import React, { useCallback, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';

import { useCheckDistributorPedagogicStepMutation } from 'api/main';
import { RoleNames } from 'utils/constants';
import { texts } from 'utils/languages/fr';

import { SubmitButton } from 'components';
import TunnelBox from '../common/TunnelBox';
import TunnelStep from '../common/TunnelStep';
import DefaultContent from './pedagogical-step/DefaultContent';

const DistributorPedagogicStep = ({ roleName, handleNextStep, userStep }) => {
    const isResubmit = useMemo(() => userStep?.successfulAttemptsNumber > 0, [userStep]);
    const isPSI = roleName === RoleNames.PSI;
    const isCommercial = roleName === RoleNames.ADMIN_CIF || isPSI;
    const [checkDistributorPedagogicStep, { isSuccess, isLoading }] =
        useCheckDistributorPedagogicStepMutation();

    const handleSubmit = useCallback(() => {
        checkDistributorPedagogicStep();
    }, [checkDistributorPedagogicStep]);

    useEffect(() => {
        if (isSuccess) {
            handleNextStep(true);
        }
    }, [isSuccess, handleNextStep]);

    return (
        <TunnelStep title={texts.NECESSARY_DOCUMENTS} maxWidth={950}>
            <TunnelBox>
                <DefaultContent isCommercial={isCommercial} isPSI={isPSI} />
            </TunnelBox>
            <SubmitButton
                loading={isLoading}
                disabled={isLoading}
                onClick={isResubmit ? handleNextStep : handleSubmit}
                text={texts.SUIVANT}
            />
        </TunnelStep>
    );
};

DistributorPedagogicStep.propTypes = {
    roleName: PropTypes.string,
    handleNextStep: PropTypes.func,
    userStep: PropTypes.object,
};

export default DistributorPedagogicStep;
